
import {Component, Vue } from 'vue-property-decorator'
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from '@/utils/util'
import editAgent from './components/edit-agent.vue'
import AreaSelect from '@/components/area-select.vue'
import {apiAgentEdit, apiAgentListAll, apiChangeStatus, apiResetPassword, apiRecharge} from '@/api/agent/agent'
@Component({
  components: {
    lsPagination,
    editAgent,
    AreaSelect
  }
})
export default class AgentList extends Vue {
  /** S Data*/
  pager: RequestPaging = new RequestPaging();
  supplierPager: RequestPaging = new RequestPaging();
  active:any = 'all'
  query:any = {}
  showDialog = false
  data = {}
  rechargeDialog = false
  rechargeForm:any = {
    id: '',
    money: ''
  }
  statusType:any = {
    all: '',
    normal: 0,
    expire: 1,
    fail: 2
  }
  /** E Data*/
  
  /** S Methods*/
  changeTab(val:any) {
    this.query.status = this.statusType[this.active]
    this.getList(1)
  }
  getList(page?:number) {
    page&&(this.pager.page = page)
    this.pager.request({
      callback: apiAgentListAll,
      params: {
        ...this.query
      }
    })
  }
  resetQuery() {
      this.query = {}
    this.getList(1)
  }
  addAgent(item:any) {
    this.data = item
    this.showDialog = true
  }
  doAddAgent(data:any) {
    console.log(data)
    apiAgentEdit(data).then(res => {
      this.getList(1)
      this.showDialog = false
    })
  }
  edit(item:any) {
    this.data = JSON.parse(JSON.stringify(item));
    this.showDialog = true
  }
  
  delay(item:any) {
  
  }
  changeStatus(id: any, status:any) {
    this.$confirm(`确认${status == 0 ? '恢复': '禁用'}供应商吗？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiChangeStatus({id, status: status}).then(res => {
        this.getList(1)
      })
    })
  }
  
  recharge(row:any) {
    this.rechargeDialog = true;
    this.rechargeForm = {
      id: row.id,
      expect_money: row.expect_money || 0,
      money: 0
    }
  }
  
  doRecharge() {
    apiRecharge(this.rechargeForm).then(res => {
      this.getList(1)
      this.rechargeDialog = false
    })
  }
  
  resetPassword(id:any)  {
    this.$confirm(`确认将此代理商账户密码充值为初始密码？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiResetPassword({id}).then(res => {
        this.getList(1)
      })
    })
  }
  /** E Methods*/
  created() {
    this.getList(1)
  }
}
